import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetReapplyRecipesPreviewQueryVariables = Types.Exact<{
  jobIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type GetReapplyRecipesPreviewQuery = { __typename?: 'Query', reapplyRecipesPreview: Array<{ __typename?: 'ReapplyRecipesPreviewResult', productionJobId: string, productionRecipeId: string, currentRecipeVersion: number, recipeDeleted: boolean, recipeName?: string | null, lotQuantity: number, currentQuantity: number, projectedQuantity: number, blockedReason?: Types.ReapplyBlockedReason | null, diff: { __typename?: 'JobDiffProjection', currentRecipeVersion: number, changedVariations: Array<{ __typename?: 'VariationDiffProjection', variationId: string, variationName: string, scalarFieldChanges: Array<{ __typename?: 'ScalarFieldChangeProjection', fieldName: string, jobValue?: unknown | null, recipeValue?: unknown | null, hasExistingOverride: boolean }>, eventIdChanges: Array<{ __typename?: 'EventIdChangeProjection', eventListName: string, eventId: string, kind: Types.EventChangeKind, expectedEventFingerprint?: string | null, hasExistingOverride: boolean }>, assignmentOverrideChanges: Array<{ __typename?: 'AssignmentOverrideChangeProjection', eventId: string, jobDefaultAssignedTo?: string | null, recipeDefaultAssignedTo?: string | null, hasExistingOverride: boolean }>, candidateTaskEventsToRegenerate: Array<{ __typename?: 'TaskEventRegenerationCandidateProjection', eventId: string, defaultAssignedTo?: string | null, isCompleted: boolean }> }>, removedVariations: Array<{ __typename?: 'RemovedVariationProjection', variationId: string, variationName: string, completedEventCount: number, plannedEventCount: number }> }, affectedChildJobs: Array<{ __typename?: 'AffectedChildJob', productionJobId: string, productionLotId: string, parentProductionJobId?: string | null, affectedVariationIds: Array<string>, lotQuantity: number, currentQuantity: number, blockedReason?: Types.ReapplyBlockedReason | null }>, preservedJobEvents: Array<{ __typename?: 'PreservedJobEventProjection', eventKind: Types.ProductionJobEventKind, eventId: string, kind: Types.PreservedJobEventKind, summary: string }> }> };

export type GetReapplyRecipesRunQueryVariables = Types.Exact<{
  runId: Types.Scalars['String']['input'];
}>;


export type GetReapplyRecipesRunQuery = { __typename?: 'Query', reapplyRecipesRun?: { __typename?: 'ReapplyRecipesRun', runId: string, status: Types.ReapplyRecipesRunStatus, totalJobs: number, processedJobs: number, appliedJobs: number, failedResults: Array<{ __typename?: 'ReapplyRecipesJobResult', productionLotId: string, productionJobId: string, productionRecipeId: string, previewedAtRecipeVersion: number, currentRecipeVersion: number, fullyReconciled: boolean, applied: Array<{ __typename?: 'RecipeChangeApplied', variationId: string, changeType: string, fieldName?: string | null, eventListName?: string | null, eventId?: string | null, expectedEventFingerprint?: string | null }>, skipped: Array<{ __typename?: 'RecipeChangeSkipped', variationId: string, changeType: string, fieldName?: string | null, eventListName?: string | null, eventId?: string | null, reason: string }>, failed: Array<{ __typename?: 'RecipeChangeFailed', variationId: string, changeType: string, fieldName?: string | null, eventListName?: string | null, eventId?: string | null, code: string, message: string }> }>, errors: Array<{ __typename?: 'ReapplyError', productionJobId: string, variationId?: string | null, eventListName?: string | null, eventId?: string | null, code: string, message: string }> } | null };

export type GetMyActiveReapplyRecipesRunsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyActiveReapplyRecipesRunsQuery = { __typename?: 'Query', myActiveReapplyRecipesRuns: Array<{ __typename?: 'ReapplyRecipesRun', runId: string }> };

export type ReapplyRecipesPreviewResultFieldsFragment = { __typename?: 'ReapplyRecipesPreviewResult', productionJobId: string, productionRecipeId: string, currentRecipeVersion: number, recipeDeleted: boolean, recipeName?: string | null, lotQuantity: number, currentQuantity: number, projectedQuantity: number, blockedReason?: Types.ReapplyBlockedReason | null, diff: { __typename?: 'JobDiffProjection', currentRecipeVersion: number, changedVariations: Array<{ __typename?: 'VariationDiffProjection', variationId: string, variationName: string, scalarFieldChanges: Array<{ __typename?: 'ScalarFieldChangeProjection', fieldName: string, jobValue?: unknown | null, recipeValue?: unknown | null, hasExistingOverride: boolean }>, eventIdChanges: Array<{ __typename?: 'EventIdChangeProjection', eventListName: string, eventId: string, kind: Types.EventChangeKind, expectedEventFingerprint?: string | null, hasExistingOverride: boolean }>, assignmentOverrideChanges: Array<{ __typename?: 'AssignmentOverrideChangeProjection', eventId: string, jobDefaultAssignedTo?: string | null, recipeDefaultAssignedTo?: string | null, hasExistingOverride: boolean }>, candidateTaskEventsToRegenerate: Array<{ __typename?: 'TaskEventRegenerationCandidateProjection', eventId: string, defaultAssignedTo?: string | null, isCompleted: boolean }> }>, removedVariations: Array<{ __typename?: 'RemovedVariationProjection', variationId: string, variationName: string, completedEventCount: number, plannedEventCount: number }> }, affectedChildJobs: Array<{ __typename?: 'AffectedChildJob', productionJobId: string, productionLotId: string, parentProductionJobId?: string | null, affectedVariationIds: Array<string>, lotQuantity: number, currentQuantity: number, blockedReason?: Types.ReapplyBlockedReason | null }>, preservedJobEvents: Array<{ __typename?: 'PreservedJobEventProjection', eventKind: Types.ProductionJobEventKind, eventId: string, kind: Types.PreservedJobEventKind, summary: string }> };

export type JobDiffProjectionFieldsFragment = { __typename?: 'JobDiffProjection', currentRecipeVersion: number, changedVariations: Array<{ __typename?: 'VariationDiffProjection', variationId: string, variationName: string, scalarFieldChanges: Array<{ __typename?: 'ScalarFieldChangeProjection', fieldName: string, jobValue?: unknown | null, recipeValue?: unknown | null, hasExistingOverride: boolean }>, eventIdChanges: Array<{ __typename?: 'EventIdChangeProjection', eventListName: string, eventId: string, kind: Types.EventChangeKind, expectedEventFingerprint?: string | null, hasExistingOverride: boolean }>, assignmentOverrideChanges: Array<{ __typename?: 'AssignmentOverrideChangeProjection', eventId: string, jobDefaultAssignedTo?: string | null, recipeDefaultAssignedTo?: string | null, hasExistingOverride: boolean }>, candidateTaskEventsToRegenerate: Array<{ __typename?: 'TaskEventRegenerationCandidateProjection', eventId: string, defaultAssignedTo?: string | null, isCompleted: boolean }> }>, removedVariations: Array<{ __typename?: 'RemovedVariationProjection', variationId: string, variationName: string, completedEventCount: number, plannedEventCount: number }> };

export type VariationDiffProjectionFieldsFragment = { __typename?: 'VariationDiffProjection', variationId: string, variationName: string, scalarFieldChanges: Array<{ __typename?: 'ScalarFieldChangeProjection', fieldName: string, jobValue?: unknown | null, recipeValue?: unknown | null, hasExistingOverride: boolean }>, eventIdChanges: Array<{ __typename?: 'EventIdChangeProjection', eventListName: string, eventId: string, kind: Types.EventChangeKind, expectedEventFingerprint?: string | null, hasExistingOverride: boolean }>, assignmentOverrideChanges: Array<{ __typename?: 'AssignmentOverrideChangeProjection', eventId: string, jobDefaultAssignedTo?: string | null, recipeDefaultAssignedTo?: string | null, hasExistingOverride: boolean }>, candidateTaskEventsToRegenerate: Array<{ __typename?: 'TaskEventRegenerationCandidateProjection', eventId: string, defaultAssignedTo?: string | null, isCompleted: boolean }> };

export type ScalarFieldChangeProjectionFieldsFragment = { __typename?: 'ScalarFieldChangeProjection', fieldName: string, jobValue?: unknown | null, recipeValue?: unknown | null, hasExistingOverride: boolean };

export type EventIdChangeProjectionFieldsFragment = { __typename?: 'EventIdChangeProjection', eventListName: string, eventId: string, kind: Types.EventChangeKind, expectedEventFingerprint?: string | null, hasExistingOverride: boolean };

export type AssignmentOverrideChangeProjectionFieldsFragment = { __typename?: 'AssignmentOverrideChangeProjection', eventId: string, jobDefaultAssignedTo?: string | null, recipeDefaultAssignedTo?: string | null, hasExistingOverride: boolean };

export type TaskEventRegenerationCandidateProjectionFieldsFragment = { __typename?: 'TaskEventRegenerationCandidateProjection', eventId: string, defaultAssignedTo?: string | null, isCompleted: boolean };

export type RemovedVariationProjectionFieldsFragment = { __typename?: 'RemovedVariationProjection', variationId: string, variationName: string, completedEventCount: number, plannedEventCount: number };

export type AffectedChildJobFieldsFragment = { __typename?: 'AffectedChildJob', productionJobId: string, productionLotId: string, parentProductionJobId?: string | null, affectedVariationIds: Array<string>, lotQuantity: number, currentQuantity: number, blockedReason?: Types.ReapplyBlockedReason | null };

export type ReapplyRecipesJobResultFieldsFragment = { __typename?: 'ReapplyRecipesJobResult', productionLotId: string, productionJobId: string, productionRecipeId: string, previewedAtRecipeVersion: number, currentRecipeVersion: number, fullyReconciled: boolean, applied: Array<{ __typename?: 'RecipeChangeApplied', variationId: string, changeType: string, fieldName?: string | null, eventListName?: string | null, eventId?: string | null, expectedEventFingerprint?: string | null }>, skipped: Array<{ __typename?: 'RecipeChangeSkipped', variationId: string, changeType: string, fieldName?: string | null, eventListName?: string | null, eventId?: string | null, reason: string }>, failed: Array<{ __typename?: 'RecipeChangeFailed', variationId: string, changeType: string, fieldName?: string | null, eventListName?: string | null, eventId?: string | null, code: string, message: string }> };

export type RecipeChangeAppliedFieldsFragment = { __typename?: 'RecipeChangeApplied', variationId: string, changeType: string, fieldName?: string | null, eventListName?: string | null, eventId?: string | null, expectedEventFingerprint?: string | null };

export type RecipeChangeSkippedFieldsFragment = { __typename?: 'RecipeChangeSkipped', variationId: string, changeType: string, fieldName?: string | null, eventListName?: string | null, eventId?: string | null, reason: string };

export type RecipeChangeFailedFieldsFragment = { __typename?: 'RecipeChangeFailed', variationId: string, changeType: string, fieldName?: string | null, eventListName?: string | null, eventId?: string | null, code: string, message: string };

export type ReapplyErrorFieldsFragment = { __typename?: 'ReapplyError', productionJobId: string, variationId?: string | null, eventListName?: string | null, eventId?: string | null, code: string, message: string };

export type ReapplyRecipesRunFieldsFragment = { __typename?: 'ReapplyRecipesRun', runId: string, status: Types.ReapplyRecipesRunStatus, totalJobs: number, processedJobs: number, appliedJobs: number, failedResults: Array<{ __typename?: 'ReapplyRecipesJobResult', productionLotId: string, productionJobId: string, productionRecipeId: string, previewedAtRecipeVersion: number, currentRecipeVersion: number, fullyReconciled: boolean, applied: Array<{ __typename?: 'RecipeChangeApplied', variationId: string, changeType: string, fieldName?: string | null, eventListName?: string | null, eventId?: string | null, expectedEventFingerprint?: string | null }>, skipped: Array<{ __typename?: 'RecipeChangeSkipped', variationId: string, changeType: string, fieldName?: string | null, eventListName?: string | null, eventId?: string | null, reason: string }>, failed: Array<{ __typename?: 'RecipeChangeFailed', variationId: string, changeType: string, fieldName?: string | null, eventListName?: string | null, eventId?: string | null, code: string, message: string }> }>, errors: Array<{ __typename?: 'ReapplyError', productionJobId: string, variationId?: string | null, eventListName?: string | null, eventId?: string | null, code: string, message: string }> };

export const ScalarFieldChangeProjectionFieldsFragmentDoc = new TypedDocumentString(`
    fragment ScalarFieldChangeProjectionFields on ScalarFieldChangeProjection {
  fieldName
  jobValue
  recipeValue
  hasExistingOverride
}
    `, {"fragmentName":"ScalarFieldChangeProjectionFields"});
export const EventIdChangeProjectionFieldsFragmentDoc = new TypedDocumentString(`
    fragment EventIdChangeProjectionFields on EventIdChangeProjection {
  eventListName
  eventId
  kind
  expectedEventFingerprint
  hasExistingOverride
}
    `, {"fragmentName":"EventIdChangeProjectionFields"});
export const AssignmentOverrideChangeProjectionFieldsFragmentDoc = new TypedDocumentString(`
    fragment AssignmentOverrideChangeProjectionFields on AssignmentOverrideChangeProjection {
  eventId
  jobDefaultAssignedTo
  recipeDefaultAssignedTo
  hasExistingOverride
}
    `, {"fragmentName":"AssignmentOverrideChangeProjectionFields"});
export const TaskEventRegenerationCandidateProjectionFieldsFragmentDoc = new TypedDocumentString(`
    fragment TaskEventRegenerationCandidateProjectionFields on TaskEventRegenerationCandidateProjection {
  eventId
  defaultAssignedTo
  isCompleted
}
    `, {"fragmentName":"TaskEventRegenerationCandidateProjectionFields"});
export const VariationDiffProjectionFieldsFragmentDoc = new TypedDocumentString(`
    fragment VariationDiffProjectionFields on VariationDiffProjection {
  variationId
  variationName
  scalarFieldChanges {
    ...ScalarFieldChangeProjectionFields
  }
  eventIdChanges {
    ...EventIdChangeProjectionFields
  }
  assignmentOverrideChanges {
    ...AssignmentOverrideChangeProjectionFields
  }
  candidateTaskEventsToRegenerate {
    ...TaskEventRegenerationCandidateProjectionFields
  }
}
    fragment ScalarFieldChangeProjectionFields on ScalarFieldChangeProjection {
  fieldName
  jobValue
  recipeValue
  hasExistingOverride
}
fragment EventIdChangeProjectionFields on EventIdChangeProjection {
  eventListName
  eventId
  kind
  expectedEventFingerprint
  hasExistingOverride
}
fragment AssignmentOverrideChangeProjectionFields on AssignmentOverrideChangeProjection {
  eventId
  jobDefaultAssignedTo
  recipeDefaultAssignedTo
  hasExistingOverride
}
fragment TaskEventRegenerationCandidateProjectionFields on TaskEventRegenerationCandidateProjection {
  eventId
  defaultAssignedTo
  isCompleted
}`, {"fragmentName":"VariationDiffProjectionFields"});
export const RemovedVariationProjectionFieldsFragmentDoc = new TypedDocumentString(`
    fragment RemovedVariationProjectionFields on RemovedVariationProjection {
  variationId
  variationName
  completedEventCount
  plannedEventCount
}
    `, {"fragmentName":"RemovedVariationProjectionFields"});
export const JobDiffProjectionFieldsFragmentDoc = new TypedDocumentString(`
    fragment JobDiffProjectionFields on JobDiffProjection {
  currentRecipeVersion
  changedVariations {
    ...VariationDiffProjectionFields
  }
  removedVariations {
    ...RemovedVariationProjectionFields
  }
}
    fragment VariationDiffProjectionFields on VariationDiffProjection {
  variationId
  variationName
  scalarFieldChanges {
    ...ScalarFieldChangeProjectionFields
  }
  eventIdChanges {
    ...EventIdChangeProjectionFields
  }
  assignmentOverrideChanges {
    ...AssignmentOverrideChangeProjectionFields
  }
  candidateTaskEventsToRegenerate {
    ...TaskEventRegenerationCandidateProjectionFields
  }
}
fragment ScalarFieldChangeProjectionFields on ScalarFieldChangeProjection {
  fieldName
  jobValue
  recipeValue
  hasExistingOverride
}
fragment EventIdChangeProjectionFields on EventIdChangeProjection {
  eventListName
  eventId
  kind
  expectedEventFingerprint
  hasExistingOverride
}
fragment AssignmentOverrideChangeProjectionFields on AssignmentOverrideChangeProjection {
  eventId
  jobDefaultAssignedTo
  recipeDefaultAssignedTo
  hasExistingOverride
}
fragment TaskEventRegenerationCandidateProjectionFields on TaskEventRegenerationCandidateProjection {
  eventId
  defaultAssignedTo
  isCompleted
}
fragment RemovedVariationProjectionFields on RemovedVariationProjection {
  variationId
  variationName
  completedEventCount
  plannedEventCount
}`, {"fragmentName":"JobDiffProjectionFields"});
export const AffectedChildJobFieldsFragmentDoc = new TypedDocumentString(`
    fragment AffectedChildJobFields on AffectedChildJob {
  productionJobId
  productionLotId
  parentProductionJobId
  affectedVariationIds
  lotQuantity
  currentQuantity
  blockedReason
}
    `, {"fragmentName":"AffectedChildJobFields"});
export const ReapplyRecipesPreviewResultFieldsFragmentDoc = new TypedDocumentString(`
    fragment ReapplyRecipesPreviewResultFields on ReapplyRecipesPreviewResult {
  productionJobId
  productionRecipeId
  currentRecipeVersion
  recipeDeleted
  recipeName
  lotQuantity
  currentQuantity
  projectedQuantity
  blockedReason
  diff {
    ...JobDiffProjectionFields
  }
  affectedChildJobs {
    ...AffectedChildJobFields
  }
  preservedJobEvents {
    eventKind
    eventId
    kind
    summary
  }
}
    fragment JobDiffProjectionFields on JobDiffProjection {
  currentRecipeVersion
  changedVariations {
    ...VariationDiffProjectionFields
  }
  removedVariations {
    ...RemovedVariationProjectionFields
  }
}
fragment VariationDiffProjectionFields on VariationDiffProjection {
  variationId
  variationName
  scalarFieldChanges {
    ...ScalarFieldChangeProjectionFields
  }
  eventIdChanges {
    ...EventIdChangeProjectionFields
  }
  assignmentOverrideChanges {
    ...AssignmentOverrideChangeProjectionFields
  }
  candidateTaskEventsToRegenerate {
    ...TaskEventRegenerationCandidateProjectionFields
  }
}
fragment ScalarFieldChangeProjectionFields on ScalarFieldChangeProjection {
  fieldName
  jobValue
  recipeValue
  hasExistingOverride
}
fragment EventIdChangeProjectionFields on EventIdChangeProjection {
  eventListName
  eventId
  kind
  expectedEventFingerprint
  hasExistingOverride
}
fragment AssignmentOverrideChangeProjectionFields on AssignmentOverrideChangeProjection {
  eventId
  jobDefaultAssignedTo
  recipeDefaultAssignedTo
  hasExistingOverride
}
fragment TaskEventRegenerationCandidateProjectionFields on TaskEventRegenerationCandidateProjection {
  eventId
  defaultAssignedTo
  isCompleted
}
fragment RemovedVariationProjectionFields on RemovedVariationProjection {
  variationId
  variationName
  completedEventCount
  plannedEventCount
}
fragment AffectedChildJobFields on AffectedChildJob {
  productionJobId
  productionLotId
  parentProductionJobId
  affectedVariationIds
  lotQuantity
  currentQuantity
  blockedReason
}`, {"fragmentName":"ReapplyRecipesPreviewResultFields"});
export const RecipeChangeAppliedFieldsFragmentDoc = new TypedDocumentString(`
    fragment RecipeChangeAppliedFields on RecipeChangeApplied {
  variationId
  changeType
  fieldName
  eventListName
  eventId
  expectedEventFingerprint
}
    `, {"fragmentName":"RecipeChangeAppliedFields"});
export const RecipeChangeSkippedFieldsFragmentDoc = new TypedDocumentString(`
    fragment RecipeChangeSkippedFields on RecipeChangeSkipped {
  variationId
  changeType
  fieldName
  eventListName
  eventId
  reason
}
    `, {"fragmentName":"RecipeChangeSkippedFields"});
export const RecipeChangeFailedFieldsFragmentDoc = new TypedDocumentString(`
    fragment RecipeChangeFailedFields on RecipeChangeFailed {
  variationId
  changeType
  fieldName
  eventListName
  eventId
  code
  message
}
    `, {"fragmentName":"RecipeChangeFailedFields"});
export const ReapplyRecipesJobResultFieldsFragmentDoc = new TypedDocumentString(`
    fragment ReapplyRecipesJobResultFields on ReapplyRecipesJobResult {
  productionLotId
  productionJobId
  productionRecipeId
  previewedAtRecipeVersion
  currentRecipeVersion
  fullyReconciled
  applied {
    ...RecipeChangeAppliedFields
  }
  skipped {
    ...RecipeChangeSkippedFields
  }
  failed {
    ...RecipeChangeFailedFields
  }
}
    fragment RecipeChangeAppliedFields on RecipeChangeApplied {
  variationId
  changeType
  fieldName
  eventListName
  eventId
  expectedEventFingerprint
}
fragment RecipeChangeSkippedFields on RecipeChangeSkipped {
  variationId
  changeType
  fieldName
  eventListName
  eventId
  reason
}
fragment RecipeChangeFailedFields on RecipeChangeFailed {
  variationId
  changeType
  fieldName
  eventListName
  eventId
  code
  message
}`, {"fragmentName":"ReapplyRecipesJobResultFields"});
export const ReapplyErrorFieldsFragmentDoc = new TypedDocumentString(`
    fragment ReapplyErrorFields on ReapplyError {
  productionJobId
  variationId
  eventListName
  eventId
  code
  message
}
    `, {"fragmentName":"ReapplyErrorFields"});
export const ReapplyRecipesRunFieldsFragmentDoc = new TypedDocumentString(`
    fragment ReapplyRecipesRunFields on ReapplyRecipesRun {
  runId
  status
  totalJobs
  processedJobs
  appliedJobs
  failedResults {
    ...ReapplyRecipesJobResultFields
  }
  errors {
    ...ReapplyErrorFields
  }
}
    fragment ReapplyRecipesJobResultFields on ReapplyRecipesJobResult {
  productionLotId
  productionJobId
  productionRecipeId
  previewedAtRecipeVersion
  currentRecipeVersion
  fullyReconciled
  applied {
    ...RecipeChangeAppliedFields
  }
  skipped {
    ...RecipeChangeSkippedFields
  }
  failed {
    ...RecipeChangeFailedFields
  }
}
fragment RecipeChangeAppliedFields on RecipeChangeApplied {
  variationId
  changeType
  fieldName
  eventListName
  eventId
  expectedEventFingerprint
}
fragment RecipeChangeSkippedFields on RecipeChangeSkipped {
  variationId
  changeType
  fieldName
  eventListName
  eventId
  reason
}
fragment RecipeChangeFailedFields on RecipeChangeFailed {
  variationId
  changeType
  fieldName
  eventListName
  eventId
  code
  message
}
fragment ReapplyErrorFields on ReapplyError {
  productionJobId
  variationId
  eventListName
  eventId
  code
  message
}`, {"fragmentName":"ReapplyRecipesRunFields"});
export const GetReapplyRecipesPreviewDocument = new TypedDocumentString(`
    query GetReapplyRecipesPreview($jobIds: [String!]!) {
  reapplyRecipesPreview(jobIds: $jobIds) {
    ...ReapplyRecipesPreviewResultFields
  }
}
    fragment ReapplyRecipesPreviewResultFields on ReapplyRecipesPreviewResult {
  productionJobId
  productionRecipeId
  currentRecipeVersion
  recipeDeleted
  recipeName
  lotQuantity
  currentQuantity
  projectedQuantity
  blockedReason
  diff {
    ...JobDiffProjectionFields
  }
  affectedChildJobs {
    ...AffectedChildJobFields
  }
  preservedJobEvents {
    eventKind
    eventId
    kind
    summary
  }
}
fragment JobDiffProjectionFields on JobDiffProjection {
  currentRecipeVersion
  changedVariations {
    ...VariationDiffProjectionFields
  }
  removedVariations {
    ...RemovedVariationProjectionFields
  }
}
fragment VariationDiffProjectionFields on VariationDiffProjection {
  variationId
  variationName
  scalarFieldChanges {
    ...ScalarFieldChangeProjectionFields
  }
  eventIdChanges {
    ...EventIdChangeProjectionFields
  }
  assignmentOverrideChanges {
    ...AssignmentOverrideChangeProjectionFields
  }
  candidateTaskEventsToRegenerate {
    ...TaskEventRegenerationCandidateProjectionFields
  }
}
fragment ScalarFieldChangeProjectionFields on ScalarFieldChangeProjection {
  fieldName
  jobValue
  recipeValue
  hasExistingOverride
}
fragment EventIdChangeProjectionFields on EventIdChangeProjection {
  eventListName
  eventId
  kind
  expectedEventFingerprint
  hasExistingOverride
}
fragment AssignmentOverrideChangeProjectionFields on AssignmentOverrideChangeProjection {
  eventId
  jobDefaultAssignedTo
  recipeDefaultAssignedTo
  hasExistingOverride
}
fragment TaskEventRegenerationCandidateProjectionFields on TaskEventRegenerationCandidateProjection {
  eventId
  defaultAssignedTo
  isCompleted
}
fragment RemovedVariationProjectionFields on RemovedVariationProjection {
  variationId
  variationName
  completedEventCount
  plannedEventCount
}
fragment AffectedChildJobFields on AffectedChildJob {
  productionJobId
  productionLotId
  parentProductionJobId
  affectedVariationIds
  lotQuantity
  currentQuantity
  blockedReason
}`);
export const GetReapplyRecipesRunDocument = new TypedDocumentString(`
    query GetReapplyRecipesRun($runId: String!) {
  reapplyRecipesRun(runId: $runId) {
    ...ReapplyRecipesRunFields
  }
}
    fragment ReapplyRecipesJobResultFields on ReapplyRecipesJobResult {
  productionLotId
  productionJobId
  productionRecipeId
  previewedAtRecipeVersion
  currentRecipeVersion
  fullyReconciled
  applied {
    ...RecipeChangeAppliedFields
  }
  skipped {
    ...RecipeChangeSkippedFields
  }
  failed {
    ...RecipeChangeFailedFields
  }
}
fragment RecipeChangeAppliedFields on RecipeChangeApplied {
  variationId
  changeType
  fieldName
  eventListName
  eventId
  expectedEventFingerprint
}
fragment RecipeChangeSkippedFields on RecipeChangeSkipped {
  variationId
  changeType
  fieldName
  eventListName
  eventId
  reason
}
fragment RecipeChangeFailedFields on RecipeChangeFailed {
  variationId
  changeType
  fieldName
  eventListName
  eventId
  code
  message
}
fragment ReapplyErrorFields on ReapplyError {
  productionJobId
  variationId
  eventListName
  eventId
  code
  message
}
fragment ReapplyRecipesRunFields on ReapplyRecipesRun {
  runId
  status
  totalJobs
  processedJobs
  appliedJobs
  failedResults {
    ...ReapplyRecipesJobResultFields
  }
  errors {
    ...ReapplyErrorFields
  }
}`);
export const GetMyActiveReapplyRecipesRunsDocument = new TypedDocumentString(`
    query GetMyActiveReapplyRecipesRuns {
  myActiveReapplyRecipesRuns {
    runId
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetReapplyRecipesPreview: build.query<GetReapplyRecipesPreviewQuery, GetReapplyRecipesPreviewQueryVariables>({
      query: (variables) => ({ document: GetReapplyRecipesPreviewDocument, variables })
    }),
    GetReapplyRecipesRun: build.query<GetReapplyRecipesRunQuery, GetReapplyRecipesRunQueryVariables>({
      query: (variables) => ({ document: GetReapplyRecipesRunDocument, variables })
    }),
    GetMyActiveReapplyRecipesRuns: build.query<GetMyActiveReapplyRecipesRunsQuery, GetMyActiveReapplyRecipesRunsQueryVariables | void>({
      query: (variables) => ({ document: GetMyActiveReapplyRecipesRunsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetReapplyRecipesPreviewQuery, useLazyGetReapplyRecipesPreviewQuery, useGetReapplyRecipesRunQuery, useLazyGetReapplyRecipesRunQuery, useGetMyActiveReapplyRecipesRunsQuery, useLazyGetMyActiveReapplyRecipesRunsQuery } = injectedRtkApi;
